<template>
	<div class="popup-warning overlay">
		<div class="popup">
			<div class="content">{{ popup.message }}</div>
			<div class="btn-wrapper">
				<Button class="popup-btn" :action="advance">{{ popup.continue_button }}</Button>
				<Button class="popup-btn" :action="close">{{ popup.close_button }}</Button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import Button from "@/components/base/Button";

export default {
	name: 'PopupWarning',
	components: {
		Button,
	},
	props: {
		externalUrl: {
			type: String,
			required: true,
		},
	},
	computed: {
		...mapState({
			popup: (state) => state.global.api.data.ui.popup_warning,
		}),
	},
	methods: {
		advance() {
			window.open(this.externalUrl, '_blank');
			this.$emit('close');
		},
		close() {
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>
	.overlay {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: auto;
		height: 100%;
		width: 100%;
		z-index: $z-top;

		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, .5);
	}

	.popup {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		max-width: 400px;
		padding: 2rem;
		background: $background-color;
		border-radius: $border-radius;
		color: $primary-color-light;
		font-family: $body-font-alt;
	}

	.content {
		text-align: center;
		margin-bottom: 1rem;
	}

	.btn-wrapper {
		width: 100%;
		display: flex;
		justify-content: space-between;

	}
	.popup-btn {
		& + & {
			margin-left: 2rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/base/PopupWarning.vue